module.exports = __webpack_public_path__ + "img/cmg3.b94d3908.png";